import { Component, ComponentInterface, JSX, Prop, State, h } from '@stencil/core';

import { store } from 'app/shared/store/store';
import { DataSpaKey } from 'app/shared/models/dataSpa';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { getDataSpaSearchParams } from 'app/shared/utilities/helper-functions';

@Component({
  tag: 'app-products-energy-container',
  styleUrl: 'product-cards-energy-container.scss',
  shadow: false
})
export class ProductCardsEnergyContainer implements ComponentInterface {
  @Prop() public readonly dataSpa;

  @State() energyProductSelected: boolean;

  componentDidLoad(): void {
    this.setProductCategoryChange();
  }

  render(): JSX.Element {
    let dataSpa = 'mode=publish&isGuidedFlow=true';
    if (this.dataSpa) {
      const dataSpaParams = getDataSpaSearchParams(this.dataSpa);
      const offerId = dataSpaParams?.get(DataSpaKey.offerId) || null;
      dataSpa = offerId ? `offerId=${offerId}&${dataSpa}` : dataSpa;
    }
    const className = this.energyProductSelected ? 'product-cards-energy-container__show' : 'product-cards-energy-container__hide';
    return <app-spa class={`product-cards-energy-container ${className}`} id="app-comparison" data-spa={dataSpa} />;
  }

  private triggerResize() {
    window.dispatchEvent(new Event('resize'));
  }

  private setProductCategoryChange(): void {
    store.onChange(StoreKeys.guidedFlowActiveCategory, (productCategory) => {
      this.energyProductSelected = productCategory === 'energy';
      if (this.energyProductSelected) {
        requestAnimationFrame(() => this.triggerResize());
      }
    });
  }
}
